/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Brand_LeadInputs */

const en_home_brand_lead = /** @type {(inputs: Home_Brand_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark Egly`)
};

const es_home_brand_lead = /** @type {(inputs: Home_Brand_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark Egly`)
};

const de_home_brand_lead = /** @type {(inputs: Home_Brand_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark Egly`)
};

const zh_home_brand_lead = /** @type {(inputs: Home_Brand_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark Egly`)
};

const ar_home_brand_lead = /** @type {(inputs: Home_Brand_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark Egly`)
};

const fr_home_brand_lead = /** @type {(inputs: Home_Brand_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark Egly`)
};

const vi_home_brand_lead = /** @type {(inputs: Home_Brand_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark Egly`)
};

const sw_home_brand_lead = /** @type {(inputs: Home_Brand_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark Egly`)
};

const th_home_brand_lead = /** @type {(inputs: Home_Brand_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark Egly`)
};

const bs_home_brand_lead = /** @type {(inputs: Home_Brand_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark Egly`)
};

const ja_home_brand_lead = /** @type {(inputs: Home_Brand_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark Egly`)
};

const ko_home_brand_lead = /** @type {(inputs: Home_Brand_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark Egly`)
};

const pt_home_brand_lead = /** @type {(inputs: Home_Brand_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark Egly`)
};

const it_home_brand_lead = /** @type {(inputs: Home_Brand_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark Egly`)
};

const sv_home_brand_lead = /** @type {(inputs: Home_Brand_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark Egly`)
};

const nl_home_brand_lead = /** @type {(inputs: Home_Brand_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark Egly`)
};

const da_home_brand_lead = /** @type {(inputs: Home_Brand_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark Egly`)
};

const nb_home_brand_lead = /** @type {(inputs: Home_Brand_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark Egly`)
};

const fi_home_brand_lead = /** @type {(inputs: Home_Brand_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark Egly`)
};

const pl_home_brand_lead = /** @type {(inputs: Home_Brand_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark Egly`)
};

const ru_home_brand_lead = /** @type {(inputs: Home_Brand_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark Egly`)
};

const tr_home_brand_lead = /** @type {(inputs: Home_Brand_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark Egly`)
};

const hi_home_brand_lead = /** @type {(inputs: Home_Brand_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark Egly`)
};

const id_home_brand_lead = /** @type {(inputs: Home_Brand_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark Egly`)
};

const ms_home_brand_lead = /** @type {(inputs: Home_Brand_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark Egly`)
};

const cs_home_brand_lead = /** @type {(inputs: Home_Brand_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark Egly`)
};

const el_home_brand_lead = /** @type {(inputs: Home_Brand_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark Egly`)
};

const he_home_brand_lead = /** @type {(inputs: Home_Brand_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark Egly`)
};

const af_home_brand_lead = /** @type {(inputs: Home_Brand_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark Egly`)
};

const hu_home_brand_lead = /** @type {(inputs: Home_Brand_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark Egly`)
};

/**
* | output |
* | --- |
* | "Mark Egly" |
*
* @param {Home_Brand_LeadInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const home_brand_lead = /** @type {((inputs?: Home_Brand_LeadInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Brand_LeadInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_home_brand_lead(inputs)
	if (locale === "de") return de_home_brand_lead(inputs)
	if (locale === "zh") return zh_home_brand_lead(inputs)
	if (locale === "ar") return ar_home_brand_lead(inputs)
	if (locale === "fr") return fr_home_brand_lead(inputs)
	if (locale === "vi") return vi_home_brand_lead(inputs)
	if (locale === "sw") return sw_home_brand_lead(inputs)
	if (locale === "th") return th_home_brand_lead(inputs)
	if (locale === "bs") return bs_home_brand_lead(inputs)
	if (locale === "ja") return ja_home_brand_lead(inputs)
	if (locale === "ko") return ko_home_brand_lead(inputs)
	if (locale === "pt") return pt_home_brand_lead(inputs)
	if (locale === "it") return it_home_brand_lead(inputs)
	if (locale === "sv") return sv_home_brand_lead(inputs)
	if (locale === "nl") return nl_home_brand_lead(inputs)
	if (locale === "da") return da_home_brand_lead(inputs)
	if (locale === "nb") return nb_home_brand_lead(inputs)
	if (locale === "fi") return fi_home_brand_lead(inputs)
	if (locale === "pl") return pl_home_brand_lead(inputs)
	if (locale === "ru") return ru_home_brand_lead(inputs)
	if (locale === "tr") return tr_home_brand_lead(inputs)
	if (locale === "hi") return hi_home_brand_lead(inputs)
	if (locale === "id") return id_home_brand_lead(inputs)
	if (locale === "ms") return ms_home_brand_lead(inputs)
	if (locale === "cs") return cs_home_brand_lead(inputs)
	if (locale === "el") return el_home_brand_lead(inputs)
	if (locale === "he") return he_home_brand_lead(inputs)
	if (locale === "af") return af_home_brand_lead(inputs)
	if (locale === "hu") return hu_home_brand_lead(inputs)
	return en_home_brand_lead(inputs)
});